import { RequestParams } from "./services/request.service"

declare global {
	interface FormData {
		from(object: any): FormData
	}
}

Object.defineProperty(FormData.prototype, 'from', {
	enumerable: false,
	value: function (object: any): FormData {

		const flatObject = new RequestParams(object).params;

		return Object.keys(flatObject).reduce((formData: FormData, key: string) => {
		
			if(flatObject[key] !== null && flatObject[key] !== undefined)
				formData.append(key, flatObject[key]);

			return formData;
		}, this);
	}
});
